module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_24.f62ed162.pdf";